import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { AdditionalServiceCreationRequest, AdditionalServiceData, AdditionalServiceEditRequest, AdditionalServiceSearchFilter } from "../../models/additional-service.model";

export const additionalServiceCreationRequest = createAction(
        '[AdditionalService] AdditionalService creation request', props<{ additionalServiceCreationRequest: AdditionalServiceCreationRequest }>());

export const additionalServiceCreationSuccess = createAction(
        '[AdditionalService] AdditionalService creation success', props<{ createdAdditionalService : AdditionalServiceData }>());

export const additionalServiceCreationFail = createAction(
        '[AdditionalService] AdditionalService creation fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const additionalServiceEdit = createAction(
        '[AdditionalService] AdditionalService edit', props<{ additionalServiceToEdit: AdditionalServiceData }>());

export const additionalServiceEditSave = createAction(
        '[AdditionalService] AdditionalService edit save', props<{ additionalServiceToEdit: AdditionalServiceEditRequest }>());

export const additionalServiceEditSaveSuccess = createAction(
        '[AdditionalService] AdditionalService edit save success', props<{ editedAdditionalService: AdditionalServiceData }>());

export const additionalServiceEditSaveFail = createAction(
        '[AdditionalService] AdditionalService edit fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const additionalServiceView = createAction(
        '[AdditionalService] AdditionalService view', props<{ additionalServiceToView: AdditionalServiceData }>());

export const additionalServiceSearchRequest = createAction(
        '[AdditionalService] AdditionalService search request', props<{ searchFilter: AdditionalServiceSearchFilter }>());

export const additionalServiceSearchAllRequest = createAction(
        '[AdditionalService] AdditionalService search all request');

export const additionalServiceSearchSuccess = createAction(
        '[AdditionalService] AdditionalService search success', props<{ searchResult: AdditionalServiceData[] }>());

export const additionalServiceSearchDataReset = createAction(
        '[AdditionalService] AdditionalService search data reset');

export const additionalServiceSearchFail = createAction(
        '[AdditionalService] AdditionalService search fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const additionalServiceDeleteRequest = createAction(
        '[AdditionalService] AdditionalService delete request', props<{ additionalServiceId: number }>());

export const additionalServiceDeleteSuccess = createAction(
        '[AdditionalService] AdditionalService delete success', props<{ additionalServiceId: number }>());

export const additionalServiceDeleteFail = createAction(
        '[AdditionalService] AdditionalService delete fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());